import React, { useEffect, useState } from 'react'
import { ActivityIndicator, Platform, ScrollView } from 'react-native'

import { i18n } from '@localization'
import { useRoute } from '@react-navigation/native'
import { publishEvent } from '@zet/analytics'
import {
  B2,
  B4,
  B5,
  BTN_SM,
  Icon,
  Stack,
  XStack,
  colors as zetColors,
} from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'

import { useMissingFields } from '../../api/missingFieldsPopup/hooks'
import { FormBuilder } from './form/form-builder'

let missedFieldsArr = []
const MissingFieldsPopup = () => {
  const { params, name } = useRoute()
  const { data, isLoading, isFetching } = useMissingFields(
    params?.brandId,
    params?.customerId
  )

  const [loadPrefilledForm, setLoadPrefilledForm] = useState(false)

  const [fields, setFields] = useState([])
  const [isEditClick, setIsEditClick] = useState(false)
  const missingFields = data?.missingFields
  const result = missingFields?.map((item) => item.code)

  const fieldValues = data?.values
  const validationSchema = data?.validationSchema || {}
  let prefilledDataObj = {}

  useEffect(() => {
    getFieldsList()
  }, [isEditClick, missingFields])

  useEffect(() => {
    showPrefilledDetails()
  }, [])

  useEffect(() => {
    publishEvent('screen_view', {
      screen_name: Platform.OS === 'web' ? name : 'missing-details',
      brand_name: params?.brandName,
      partner_id: params?.brandId,
      customer_id: params?.customerId,
      customer_name: params?.customerName,
      customer_phone_number: params?.customerPhoneNumber,
    })
  }, [])

  const getFieldsList = () => {
    missedFieldsArr = []
    if (isEditClick) {
      setFields(data?.formFields)
    } else {
      missingFields?.forEach?.((item) => {
        if (item?.code !== undefined) {
          const getMissingFields = data?.formFields.filter(
            (d) => d.code === item.code
          )
          missedFieldsArr.push(getMissingFields[0])
        }
      })

      setFields(missedFieldsArr)
    }
  }

  const ocFields = fields?.sort(function (a, b) {
    return result?.indexOf(b.code) - result.indexOf(a.code)
  })

  const showPrefilledDetails = () => {
    data?.formFields?.forEach((item, index) => {
      prefilledDataObj = { ...prefilledDataObj, [item.code]: item.name }
    })
    return Object.keys(prefilledDataObj).map((item, index) =>
      fieldValues[item] ? (
        <XStack className="mt-1 justify-between">
          <B5 className="flex-1">{prefilledDataObj[item]}</B5>
          <B4 className="flex-1">{fieldValues[item]}</B4>
        </XStack>
      ) : (
        <></>
      )
    )
  }

  const onEditDetailsClick = () => {
    setIsEditClick(true)
    publishEvent('click_action', {
      item_name: 'missing_fields_edit_details',
      brand_name: params?.brandName,
      partner_id: params?.brandId,
    })
  }

  if (isLoading) {
    return <ActivityIndicator size={'large'} color={'blue'} />
  }

  return (
    <ScrollView className="bg-white px-2">
      <Stack>
        <B2 className="mx-2">
          {i18n.t('missingFieldsPopup.subHeading', {
            customerName: params?.customerName,
          })}
        </B2>
        <Stack className="flex-1">
          <FormBuilder
            ocFields={ocFields}
            fieldValues={fieldValues}
            validationSchema={validationSchema}
            customerId={params?.customerId}
            generateLinkParams={params?.generateLinkParams}
            brandId={params?.brandId}
            customerName={params?.customerName}
            brandName={params?.brandName}
            customerPhoneNumber={params?.customerPhoneNumber}
            leadSource={params?.leadSource}
          />
        </Stack>
        {!isEditClick ? (
          <>
            <B2 className="text-grays-70 mx-2">
              {i18n.t('missingFieldsPopup.recommendationGenerate')}
            </B2>
            <Stack className="bg-grays-20 mx-2 mt-2 p-3">
              {showPrefilledDetails()}
              <Stack className="mt-1 self-end">
                <Pressable className="flex-row" onPress={onEditDetailsClick}>
                  <Icon type="Edit" color={zetColors.primary[100]} size={20} />
                  <BTN_SM className="text-primary-100">
                    {i18n.t('missingFieldsPopup.editDetails')}
                  </BTN_SM>
                </Pressable>
              </Stack>
            </Stack>
          </>
        ) : (
          <></>
        )}
      </Stack>
    </ScrollView>
  )
}

export default MissingFieldsPopup
